import SessionEventProto from "../session-event-proto"

// Live push for a relations link (public.relation, the new system).
// The backend sends object = EntityType.RELATION (72) with the
// relation toJson as `data` -- id + source/target endpoints (ids encoded,
// *ItemType are plain EntityType ints) plus the embedded `sourceItem` /
// `targetItem` entity summaries. Only `new` and `delete` are emitted; a link
// has no mutable body.
//
// Published on its OWN modelBus channel ('relation'), kept separate from
// the legacy blocker channel ('dependency').
export default class SessionRelationEvent extends SessionEventProto {

    process() {
        if (this.isDifferentCompany()) return false

        gd.modelBus.newUpdate(
            'relation',
            this.method,
            this.data.id,
            this.data,
            {relationId: this.data.id},
        )
    }
}
